import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription, of as observableOf, merge } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { Detail, Status, Request } from '../request.model';
import { RequestsService } from '../requests.service';
import { startWith, switchMap, map, catchError } from 'rxjs/operators';
import { Customer } from 'src/app/settings/customer-settings/customer-settings.model';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DeletionDialogComponent } from 'src/app/layout/deletion-dialog/deletion-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTabGroup } from '@angular/material/tabs';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
  MatNoDataRow
} from '@angular/material/table';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { NgClass, DatePipe } from '@angular/common';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { RouterLink } from '@angular/router';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { PaginatorSpinnerComponent } from '../../layout/paginator-spinner/paginator-spinner.component';

@Component({
  selector: 'open-requests',
  templateUrl: './open-requests.component.html',
  styleUrls: ['./open-requests.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatSuffix,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    NgClass,
    MatIconButton,
    MatProgressSpinner,
    MatTooltip,
    CdkCopyToClipboard,
    MatChip,
    MatButton,
    RouterLink,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatNoDataRow,
    PaginatorSpinnerComponent,
    MatPaginator,
    DatePipe,
    MatChipSet
  ]
})

export class OpenRequestsComponent implements OnInit, AfterViewInit {
  constructor(
    private requestService: RequestsService,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
    private spinnerService: SpinnerService
  ) {
  }


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) messagePaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  @Output()
  tabChange = new EventEmitter<any>();
  @Output()
  requestDeleted = new EventEmitter<any>();
  @Output()
  archivedRequest = new EventEmitter<any>();

  @Input() private data: any;

  displayedColumns: string[] = [
    'arrow',
    'requestId',
    'customerInfo',
    'requestStatus',
    'destination',
    'packageInfo',
    'viewDetails',
    'actions',
  ];
  tabledata: Request[] = [];
  dataSource = new MatTableDataSource();

  collapsedTable: {
    id: number;
    open: boolean;
  };

  displayedDetailColumns: string[] = [
    'sendDate',
    'receivedDate',
    'receivedFrom',
    'sendTo',
    'subject'];

  detailData: Detail | null;

  notAssigned = false;
  displayedMessageColumns: string[] = ['actions', 'from', 'sendTo', 'date', 'subject'];


  // selection = new SelectionModel(true, []);

  searchForm: UntypedFormGroup;
  dialogConfig = new MatDialogConfig();

  pageSizeOptions: any[] = [10, 20, 50, 100, 500];
  pageSize = this.pageSizeOptions[2];
  orderBy = 'id';
  sortDirection = 'desc';
  searchSubscription: Subscription;
  resultsLength = 0;

  openList: Request[] = [];
  openListRequest: any;


  paginationSpinnerStarted = false;

  messageRequest: Request = null;   // Request which is used to display messages in the detail table
  messagesLoading = false;          // flag for displaying messages in table & loading icon

  ngOnInit(): void {

    // subscribe to changing paginationSpinner
    this.spinnerService.spinner$.subscribe((data: any) => {
      this.paginationSpinnerStarted = data;
    });

    this.searchForm = new UntypedFormGroup({
      filter: new UntypedFormControl(''),
    });
    // show opened requests as a default
    this.collapsedTable = {id: 0, open: false};

    this.requestService.tabChange.subscribe((data: any) => {
      this.collapsedTable = {id: 0, open: false};
    });

    this.requestService.refreshRequest.subscribe(data => {
      this.refresh();
    });

    this.requestService.getRequestsWithNewMessages(0).subscribe(requests => {
      this.requestService.openRequestsWithNewMessages = requests;
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.refresh();
  }

  refresh(): void {
    this.searchForOpenRequest();
    this.requestService.getRequestsWithNewMessages(0).subscribe(requests => {
      this.requestService.openRequestsWithNewMessages = requests;
    });
  }


  searchForOpenRequest(): void {
    merge(this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.spinnerService.startSpinner();
          this.spinnerService.startPaginationSpinner();
          return this.requestService.getRequestByStatus(this.paginator.pageIndex, this.pageSize, this.orderBy, this.sortDirection, 0);
        }),
        map((data: any) => {
          this.resultsLength = data.totalElements;
          return data;
        }),
        catchError((err: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(err.status);
          return observableOf([]);
        })
      )
      .subscribe((requests: any) => {

          this.openList = requests.content;
          this.openListRequest = requests;
          this.dataSource = new MatTableDataSource<Request>(this.openList);
          this.spinnerService.stopSpinner();
          this.spinnerService.stopPaginationSpinner();
          this.requestService.openCounter.emit(this.openListRequest.totalElements);
        }
      );
  }


  getRequestById(collapsedTable: any, requestId: number): void {
    if (collapsedTable.id !== requestId) {
      this.collapsedTable.open = false;
      this.messageRequest = null;
      this.messagesLoading = true;

      this.collapseTable(requestId);

      this.requestService.getRequestById(requestId).subscribe((data: Request) => {
          this.messagesLoading = false;
          this.messageRequest = data;
        },
        (error: any) => {
          this.snackbarService.openError(error.status);
          this.messagesLoading = false;
        });
    }
  }

  // -- menu --
  deleteRequest(request: Request, index: number): void {
    const dialogRef = this.dialog.open(
      DeletionDialogComponent,
      this.dialogConfig
    );

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.spinnerService.startSpinner();
        this.requestService.deleteRequest(request.id).subscribe(
          () => {
            this.spinnerService.stopSpinner();
            this.requestService.refreshRequests(true);
            this.snackbarService.openSuccess();
          },
          (error: any) => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openError(error.status);
          }
        );
      }
    });
  }


  pageChangeEvent(event): void {
    this.pageSize = event.pageSize;
  }

  closeRequest(request: Request): void {
    this.spinnerService.startSpinner();

    this.requestService.getRequestById(request.id).subscribe((responseRequest: Request) => {

      if (responseRequest.closed === true) {
        responseRequest.closed = false;
        responseRequest.requestStatus = Status.NEW;
      } else {
        responseRequest.closed = true;
        responseRequest.requestStatus = Status.CLOSED;
      }

      this.requestService.putRequest(responseRequest).subscribe(
        () => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openSuccess();
          this.requestService.refreshRequests(true);
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    });

  }

  getShortenedRequestId(requestId: string): string {
    return requestId.slice(0, 16) + '...';
  }

  // --detail table--
  collapseTable(id: number): void {
    const a = this.collapsedTable.id !== id;
    this.collapsedTable.id = id;
    this.collapsedTable.open = !this.collapsedTable.open || a;
  }

  // -- status row --
  getStatus(status: string): string {
    if (status === Status.WAITING_FOR_ACTION) {
      return 'Waiting for action';
    }

    if (status === Status.WAITING_FOR_ANSWER) {
      return 'Waiting for answer';
    }

    if (status === Status.NEW) {
      return 'New';
    }

    if (status === Status.CLOSED) {
      return 'Closed';
    }

    if (status === Status.NOT_INVOICED) {
      return 'Not Invoiced';
    }

    if (status === Status.INVOICED) {
      return 'Invoiced';
    }
  }

  getStatusStyle(status: string): string {
    if (
      status === Status.WAITING_FOR_ANSWER ||
      status === Status.WAITING_FOR_ACTION
    ) {
      return 'waitingStatus';
    }

    if (status === Status.NEW) {
      return 'inactiveStatus';
    }

    if (status === Status.CLOSED) {
      return 'activeStatus';
    }

    if (status === Status.INVOICED || status === Status.NOT_INVOICED) {
      return 'invoiceStatus';
    }
  }

  // -- search --

  clearSearch(): void {
    // @ts-ignore
    this.searchForm.controls['filter'].setValue('');
    this.applyFilter();
  }

  applyFilter(): void {
    const filterValue = this.searchForm.value.filter;

    // filter also for customer column
    this.dataSource.filterPredicate = (customer: Customer, filter: string) => {
      const transformedFilter = filter.trim().toLowerCase();

      const listAsFlatString = (obj): string => {
        let returnVal = '';

        Object.values(obj).forEach((val) => {
          if (typeof val !== 'object') {
            returnVal = returnVal + ' ' + val;
          } else if (val !== null) {
            returnVal = returnVal + ' ' + listAsFlatString(val);
          }
        });

        return returnVal.trim().toLowerCase();
      };

      return listAsFlatString(customer).includes(transformedFilter);
    };

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  toggleRow(element: any) {
    if (this.detailData === element) {
      this.detailData = null;
    } else {
      this.detailData = element;
      this.getRequestById(this.collapsedTable, element.id);
    }
  }


}
